import * as React from "react";
import { useRouter } from "next/router";
import { pipe } from "fp-ts/function";
import { nonEmptyArray, option } from "fp-ts";
import { optionOrChain, someOrThrow } from "../../../utils/fp";
import { Tab, Tabs } from "@mui/material";
import { RaceId } from "../../../domain/event";
import { Route, shallowPush } from "../../../utils/routing/routing";
import { NonEmptyArray } from "fp-ts/NonEmptyArray";
import { EventDetailRace } from "../../../hooks/event";
import { tapLog } from "../../../utils/testing/tapLog";

interface Props {
    races: NonEmptyArray<EventDetailRace>;
    state: RaceTabState;
}
export const RaceTabs = (p: Props) => {
    return p.races.length === 1 ? null : (
        <Tabs
            sx={{
                // mt: 1,
                mb: 1,
                maxWidth: "90vw", // TODO this should be not needed!
            }}
            value={p.state.selectedRaceId}
            onChange={(e, newValue: RaceId) => {
                p.state.change(newValue);
            }}
        >
            {pipe(
                p.races,
                nonEmptyArray.map((race) => (
                    <Tab key={race.id} value={race.id} label={race.title} />
                ))
            )}
        </Tabs>
    );
};

interface RaceTabState {
    selectedRaceId: RaceId;
    change: (raceId: RaceId) => void;
}

// todo route
export const useRaceTabState = (
    races: NonEmptyArray<EventDetailRace>,
    route: Route,
    defaultSelectedRaceId?: RaceId,
    onChange?: () => void,
    subdomain?: string
): RaceTabState => {
    const router = useRouter();

    const query = pipe(
        subdomain == null ? router.query : { ...router.query, subdomain },
        route.queryCodec.decode,
        option.fromEither
    );

    const selectedRaceId = pipe(
        query,
        option.chain((q) => option.fromNullable(q.raceId)),
        optionOrChain(() => option.fromNullable(defaultSelectedRaceId)),
        option.getOrElse(() =>
            pipe(races, nonEmptyArray.head, (race) => race.id)
        )
    );

    return {
        selectedRaceId,
        change: (raceId: RaceId) => {
            pipe(query, someOrThrow, (q) => {
                if (onChange != null) {
                    onChange();
                }
                shallowPush(
                    route.route({
                        ...q,
                        raceId,
                    }),
                    router
                );
            });
        },
    };
};
